import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { CareerIcon } from 'atoms';
import { Colors } from 'context';
import { careerLayout, careerType } from 'services/careerType';

export interface ICareerBackLink {
  to: string;
  label: string;
}

/**
 * Возврат в родительский раздел (ТЗ 0071, п. 3).
 *
 * Экраны второго уровня — урок и страница профессии — возвращают к своему
 * списку («← Nauka», «← Zawody») одной ссылкой одного вида. Экраны первого
 * уровня возврата не требуют: у каждого свой пункт бокового меню (доработка
 * 15.09 — владелец спросил, «как уйти с этой страницы назад»).
 */
export const CareerBackLink = ({ to, label }: ICareerBackLink) => (
  <Back to={to}>
    <CareerIcon name="arrowRight" size={18} />
    {label}
  </Back>
);

const Back = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: ${careerLayout.hitTarget}px;
  color: ${Colors.black};
  ${careerType.bodyStrong()};

  svg {
    transform: rotate(180deg);
  }

  &:hover {
    color: ${Colors.black};
    text-decoration: underline;
  }
`;
